import {observer} from 'mobx-react-lite';
import React from 'react';
import {Pressable, Text} from 'react-native';

import {variance} from '../styling';

export type CalendarCellProps = {
  day: number;
  active: boolean;
  disabled: boolean;
  first: boolean;
  last: boolean;
  onPress: () => void;
};

export default observer(function CalendarCell({
  day,
  active,
  disabled,
  last,
  first,
  onPress,
}: CalendarCellProps) {
  return (
    <Item last={last} first={first} disabledStyle={disabled} onPress={onPress}>
      <ItemText active={active} disabled={disabled}>
        {day}
      </ItemText>
    </Item>
  );
});

const Item = variance(Pressable)((theme) => ({
  root: {
    flexBasis: `${100 / 7}%`,
    height: 44,
  },

  disabledStyle: {
    backgroundColor: theme.chroma(theme.palette.backdrop).alpha(0.1).hex(),
    borderRadius: 0,
  },
  last: {
    borderTopRightRadius: 6,
    borderBottomRightRadius: 6,
  },

  first: {
    borderTopLeftRadius: 6,
    borderBottomLeftRadius: 6,
  },
}));

const ItemText = variance(Text)((theme) => ({
  root: {
    lineHeight: 44,
    textAlign: 'center',
    fontSize: 13,
    color: theme.palette.darkText,
  },
  active: {
    fontWeight: '600',
    color: theme.palette.primary,
  },

  disabled: {
    color: theme.palette.border,
  },
}));
